<template id="mapPoiListTmpl">
	<div>
		
		<v-card-subtitle>{{$t('lbl.pois')}}</v-card-subtitle>

		<v-card-text v-if="poilist != null && poilist != []">
			<v-alert dense outlined type="info">{{ $t('lbl.pollingIntervalTime')}}: {{poiListintervalTime}} </v-alert>
		</v-card-text>

		<v-card-text v-if="poilist != null && poilist != []">
			<div v-for="item in poilist" v-bind:key="item.poi_id">
				<v-row>
					<v-col cols="12" md="8">
						<v-icon class="alertIcon mr-2" v-if="item.alert" >mdi-alert</v-icon>
						<span class="text-capitalize font-weight-bold">
							{{item.things[0].thing_name}}
						</span>
					</v-col>

					<v-col cols="12" md="4" class="text-left text-md-right">

						<v-tooltip top 
							v-if="isEmptyObj(item) == false && isEmptyObj(item.things) == false && isEmptyObj(item.things[0]) == false && isEmptyString(item.things[0].thing_link) == false">
							<template v-slot:activator="{ on, attrs }">
								<v-btn 
									class="button-secondary mr-2" fab small depressed
									v-bind="attrs"
									v-on="on"
									v-on:click="openPoiThingLink(item.things[0].thing_link)"
									><v-icon>list_alt</v-icon></v-btn>
							</template>
							<span>{{ $t('btn.poiThingLink')}}</span>
						</v-tooltip>	
						
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn 
									class="button-secondary mr-2" fab small depressed
									v-bind="attrs"
									v-on="on" 
									v-on:click="openGeneralPoiDetails(item.poi_id)"
									><v-icon>zoom_in</v-icon></v-btn>
							</template>
							<span>{{ $t('btn.poiThingCurrentValues')}}</span>
						</v-tooltip>	
						
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
							<v-btn 
								class="button-secondary mr-2" fab small depressed 
								v-bind="attrs"
								v-on="on" 
								v-on:click="operPoiChartExternal(item.poi_id)"
								><v-icon>bar_chart</v-icon></v-btn>
							</template>
							<span>{{ $t('btn.poiThingStats')}}</span>
						</v-tooltip>

					</v-col>

				
				</v-row>
				<v-divider></v-divider>
			</div>
		</v-card-text>
		

		<v-card-text v-else>{{$t('err.noPoiFound')}}</v-card-text>	

		<!-- POI DETAILS -->
		<dlg-poi-details ref="dlgPoiDetails" :orgid="orgid" :siteid="siteid" :mapDetailObj="mapDetailObj"></dlg-poi-details>

		<!-- POI CHART EXTERNAL -->
		<dlg-thing-stats ref="dlgThingStatsExternal" :orgid="orgid" :siteid="siteid" :mapDetailObj="mapDetailObj"></dlg-thing-stats>

	</div>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';
import ctDialogPoiDetails from "@/components/commons/ctDialogPoiDetails.vue";
import ctDialogThingStats from "@/components/commons/ctDialogThingStats.vue";

export default {
	i18n,
    data: () => ({
		orgid: null,
		siteid: null,
		poiListInterval: null,
		poiListintervalTime: 50000, 
		poilist: [],
		mapDetailObj:null,
	}),
	components: {
		"dlg-poi-details":ctDialogPoiDetails,
		"dlg-thing-stats":ctDialogThingStats
    },
	mounted() {
		
	},
	created() {
		this.mapDetailObj = this.getEmptyMap();	
		events.$on(constants.EVENT_DIALOG_RENDER_3D_OPEN, () => {
			this.stopPoiListPolling();
		});
		events.$on(constants.EVENT_DIALOG_RENDER_3D_CLOSE, () => {
			this.startPoiListPolling();
		});
		events.$on(constants.EVENT_DIALOG_STATS_OPEN, () => {
			this.stopPoiListPolling();
		});
		events.$on(constants.EVENT_DIALOG_STATS_CLOSE, () => {
			this.startPoiListPolling();
		});
	},
	destroyed() {
		this.stopPoiListPolling();
		events.$off(constants.EVENT_DIALOG_RENDER_3D_OPEN);
		events.$off(constants.EVENT_DIALOG_RENDER_3D_CLOSE);
		events.$off(constants.EVENT_DIALOG_STATS_OPEN);
		events.$off(constants.EVENT_DIALOG_STATS_CLOSE);
	},	
	methods: {
		injectMapDetailObj(orgid, siteid, mapDetailObj)
		{
			//=== 
			//HO DOVUTO PROCEDERE COSI PERCHE L'OGGETTO PASSATO TRAMITE PROPS
			// SI AGGIORNAVA DOPO CON UN LEGGERO RITARDO ED IL PRIMO POLLING ANDAVA MALE
			//===
			this.orgid = orgid;
			this.siteid = siteid; 
			this.mapDetailObj = mapDetailObj;
		},		
		startPoiListPolling()
		{
			//=== STOP POLLING PRECEDENTE SE CI FOSSE
			clearInterval(this.poiListInterval);

			//=== PRIMA LETTURA INIZIALE
			this.loadPoiList();

			//=== INIZIO POLLING
			// POLLING NON FUNZIONA
			this.poiListInterval = setInterval(this.loadPoiList, this.poiListintervalTime);
			
			//alert("START POLLING");
		},
		stopPoiListPolling()
		{
			clearInterval(this.poiListInterval);
		},
		loadPoiList() 
		{
			if(this.isEmptyString(this.orgid))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			}
			else if(this.isEmptyString(this.siteid))
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			} 
			else if(this.isEmptyObj(this.mapDetailObj) || (!this.isEmptyObj(this.mapDetailObj) && this.isEmptyString(this.mapDetailObj.sitemap_id) ))
			{
				this.$root.setDialogMsg(i18n.t("err.mapSelectedNotValid"));
			} 
			else 
			{
				//var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.orgid + '/sites/'+ this.siteid +'/maps/' + this.mapDetailObj.sitemap_id + '/pois';

				var endpoint2go = constants.ENDPOINT_GATEWAY_POI_LIST_ALERT;
				endpoint2go += "?org=" + this.orgid;
				endpoint2go += "&site=" + this.siteid;
				endpoint2go += "&map=" + this.mapDetailObj.sitemap_id;
				//console.log(endpoint2go);
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadPoiList, 'err.loadingPois');
			} 
		},
		callbackLoadPoiList(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.poilist = this.getSecurePoiList(responseData, true);	
			} 
			else 
			{
				this.$root.setDialogMsg(i18n.t('err.loadingPois'));
			}
		},
		openGeneralPoiDetails(poi_id)
		{
			if(this.isEmptyString(this.orgid))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			}
			else if(this.isEmptyString(this.siteid))
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			} 
			else if(this.isEmptyObj(this.mapDetailObj) || (!this.isEmptyObj(this.mapDetailObj) && this.isEmptyString(this.mapDetailObj.sitemap_id)))  
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
			else if(this.isEmptyString(poi_id))   
			{
				this.$root.setDialogMsg(i18n.t('err.poiSelectedNotValid'));
			}
			else
			{
				var endpoint2go = constants.ENDPOINT_GATEWAY_POI_DETAILS;
				endpoint2go += "?org=" + this.orgid;
				endpoint2go += "&site=" + this.siteid;
				endpoint2go += "&map=" + this.mapDetailObj.sitemap_id;
				endpoint2go += "&poi=" + poi_id;
				//endpoint2go += "&accessToken=" + this.getUserAccessToken();
				//this.$root.genericGetCallEngine(endpoint2go, this.callbackOpenGeneralPoiDetails, 'err.loadingPoi');
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackOpenGeneralPoiDetails, 'err.loadingPoi');
			}
		},
		callbackOpenGeneralPoiDetails(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.$refs.dlgPoiDetails.openDlgPoiDetails(responseData);
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingPoi"));
			}	
		},
		operPoiChartExternal(poi_id)
        {
            this.$refs.dlgThingStatsExternal.openThingStats(poi_id);
        }, 
		openPoiThingLink(link)
        {
            window.open(link, '_blank');
        },
	}	
}
</script>